import type { SettingsSource } from '../models/settings-hub.model';

import { action, field } from './settings-builders';
import { taxRegimeOptions } from './settings-options';
import { BIC_SWIFT_PATTERN } from './settings-patterns';

export const EINVOICE_SUBCATEGORY: SettingsSource = {
    id: 'einvoice',
    visibleWhen: ({ getPreference }) => getPreference('general.address_country') === 'IT',
    cards: [
        {
            id: 'sending',
            settings: [
                field.text('e_invoice.invoice_prefix', 'SETTINGS.SETTINGS.INVOICE_PREFIX'),
                field.text('e_invoice.merchant.vat_subcode', 'SETTINGS.SETTINGS.VAT_SUBCODE'),
                action('open-einvoice-setup', 'SETTINGS.SETTINGS.MOD_SEND_INVOICE', { icon: 'settings' })
            ]
        },
        {
            id: 'merchant',
            settings: [
                field.text('e_invoice.merchant.company_name', 'SETTINGS.SETTINGS.DENOMINATION', { maxLength: 80 }),
                field.text('e_invoice.merchant.first_name', 'SETTINGS.SETTINGS.FIRST_NAME', { maxLength: 60 }),
                field.text('e_invoice.merchant.last_name', 'SETTINGS.SETTINGS.LAST_NAME', { maxLength: 60 }),
                field.text('e_invoice.merchant.country', 'SETTINGS.SETTINGS.COUNTRY', { maxLength: 2 }),
                field.text('e_invoice.merchant.vat_code', 'SETTINGS.SETTINGS.VAT_CODE', { maxLength: 28 }),
                action('search-vat-merchant', 'SETTINGS.HUB.ACTIONS.SEARCH_MERCHANT_BY_VAT', { icon: 'search' }),
                field.text('e_invoice.merchant.tax_code', 'SETTINGS.SETTINGS.TAX_CODE', { maxLength: 16 }),
                field.select('e_invoice.merchant.tax_regime', 'SETTINGS.SETTINGS.TAX_REGIME', { options: taxRegimeOptions })
            ]
        },
        {
            id: 'head-office',
            settings: [
                field.text('e_invoice.merchant.head_office.street', 'SETTINGS.SETTINGS.ADDRESS_STREET', { maxLength: 60 }),
                field.text('e_invoice.merchant.head_office.number', 'SETTINGS.SETTINGS.ADDRESS_NUMBER', { maxLength: 8 }),
                field.text('e_invoice.merchant.head_office.zip', 'SETTINGS.SETTINGS.ADDRESS_ZIP', { maxLength: 5 }),
                field.text('e_invoice.merchant.head_office.city', 'SETTINGS.SETTINGS.ADDRESS_CITY', { maxLength: 60 }),
                field.text('e_invoice.merchant.head_office.prov', 'SETTINGS.SETTINGS.ADDRESS_COUNTY', { maxLength: 2 }),
                field.text('e_invoice.merchant.head_office.country', 'SETTINGS.SETTINGS.ADDRESS_COUNTRY', { maxLength: 2 })
            ]
        },
        {
            id: 'contacts',
            settings: [
                field.text('e_invoice.merchant.phone', 'SETTINGS.SETTINGS.PHONE', { maxLength: 12 }),
                field.text('e_invoice.merchant.fax', 'SETTINGS.SETTINGS.FAX', { maxLength: 12 }),
                field.email('e_invoice.merchant.email', 'SETTINGS.SETTINGS.EMAIL', { maxLength: 256 }),
                field.email('e_invoice.merchant.email_pec', 'SETTINGS.SETTINGS.EMAIL_PEC', { maxLength: 256 })
            ]
        },
        {
            id: 'bank',
            settings: [
                field.text('e_invoice.bank_merchant_name', 'SETTINGS.SETTINGS.BANK_MERCHANT_NAME', { maxLength: 200 }),
                {
                    id: 'e_invoice.bank_name',
                    preferenceKey: 'e_invoice.bank_name',
                    control: 'text',
                    label: 'SETTINGS.SETTINGS.BANK_NAME',
                    maxLength: 80,
                    required: ({ values }) => !!(values['e_invoice.bank_merchant_name'] || values['e_invoice.bank_iban'])
                },
                {
                    id: 'e_invoice.bank_iban',
                    preferenceKey: 'e_invoice.bank_iban',
                    control: 'text',
                    label: 'SETTINGS.SETTINGS.IBAN',
                    maxLength: 34,
                    required: ({ values }) => !!(values['e_invoice.bank_merchant_name'] || values['e_invoice.bank_name'])
                },
                field.text('e_invoice.bic', 'SETTINGS.SETTINGS.BIC_SWIFT', { pattern: BIC_SWIFT_PATTERN })
            ]
        }
    ]
};
